import { createReducer } from '@reduxjs/toolkit';

import getUploadsList from '../../thunks/users/getUploadsList';

const initialState = {
  loading: false,
  error: null,
  data: [],
  next: null,
  currentPage: 0,
  lastPage: 0,

};

const getUploadsListReducer = createReducer(initialState, {
  [getUploadsList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),

  [getUploadsList.fulfilled]: (state, {
    payload: {
      data,
      next_page_url: nextPageUrl,
      current_page: currentPage,
      last_page: lastPage,
      refresh
    }
  }) => ({
    ...state,
    loading: false,
    next: nextPageUrl,
    currentPage,
    lastPage,
    data: [
      ...(!refresh ? state?.data : []),
      ...data
    ]
  }),
  [getUploadsList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getUploadsListReducer;
